var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40764 15.4551V17.3159C9.40764 18.8926 8.00763 20.1668 6.28388 20.1668C4.56013 20.1668 3.15137 18.8926 3.15137 17.3159V15.4551C3.15137 17.0317 4.55138 18.1501 6.28388 18.1501C8.00763 18.1501 9.40764 17.0226 9.40764 15.4551Z",
    stroke: "#4318FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40621 12.9344C9.40621 13.3928 9.28371 13.8144 9.07371 14.1811C8.55746 15.0702 7.4987 15.6294 6.2737 15.6294C5.0487 15.6294 3.98994 15.0611 3.47369 14.1811C3.26369 13.8144 3.14124 13.3928 3.14124 12.9344C3.14124 12.1461 3.49122 11.4402 4.05122 10.9269C4.61997 10.4044 5.39869 10.0928 6.26494 10.0928C7.13119 10.0928 7.90996 10.4136 8.47871 10.9269C9.05621 11.4311 9.40621 12.1461 9.40621 12.9344Z",
    stroke: "#4318FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40764 12.9338V15.4547C9.40764 17.0313 8.00763 18.1497 6.28388 18.1497C4.56013 18.1497 3.15137 17.0222 3.15137 15.4547V12.9338C3.15137 11.3572 4.55138 10.083 6.28388 10.083C7.15013 10.083 7.92891 10.4038 8.49766 10.9171C9.05766 11.4305 9.40764 12.1455 9.40764 12.9338Z",
    stroke: "#4318FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2501 10.0561V11.9444C19.2501 12.4486 18.8651 12.8611 18.3751 12.8794H16.66C15.715 12.8794 14.8488 12.1552 14.7701 11.1652C14.7176 10.5877 14.9275 10.0469 15.295 9.67107C15.6188 9.32274 16.065 9.12109 16.555 9.12109H18.3751C18.8651 9.13943 19.2501 9.55189 19.2501 10.0561Z",
    stroke: "#4318FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.62467V7.79134C1.75 5.29801 3.185 3.55634 5.41625 3.26301C5.64375 3.22634 5.88 3.20801 6.125 3.20801H14C14.2275 3.20801 14.4463 3.21716 14.6562 3.25383C16.9137 3.52883 18.375 5.27967 18.375 7.79134V9.12052H16.555C16.065 9.12052 15.6187 9.32216 15.295 9.6705C14.9275 10.0463 14.7175 10.5872 14.77 11.1647C14.8488 12.1547 15.715 12.8788 16.66 12.8788H18.375V14.208C18.375 16.958 16.625 18.7913 14 18.7913H11.8125",
    stroke: "#4318FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBalance);
export default __webpack_public_path__ + "static/media/walletBalance.a7af806df5111b9bb6f75e37a8449a5a.svg";
export { ForwardRef as ReactComponent };